import { Alert, Box, TextButton } from '@zillow/constellation-10';
import type { SatelliteWebLandlordGetScreeningCriterionDto } from '@zg-rentals/ts-satellite-client';

type ComplianceAlertsProps = {
  creditAlert?: SatelliteWebLandlordGetScreeningCriterionDto | null;
  incomeAlert?: SatelliteWebLandlordGetScreeningCriterionDto | null;
};

export default function ComplianceAlerts({ creditAlert, incomeAlert }: ComplianceAlertsProps) {
  const alerts = [creditAlert, incomeAlert].flatMap((criteria) => (criteria?.alert ? [criteria.alert] : []));

  if (alerts.length === 0) return null;

  return (
    <Box css={{ display: 'flex', flexDirection: 'column', gap: 'default', marginBottom: 'default' }}>
      {alerts.map((alert, index) => {
        const links = alert.links ?? [];
        return (
          <Alert
            key={`${alert.body}-${index}`}
            tone="warning"
            actionButton={
              links.length > 0 ? (
                <Box css={{ display: 'flex', flexWrap: 'wrap', gap: 'tight' }}>
                  {links.map((link) => (
                    <TextButton asChild key={`${alert.body}-${link.text}`} textStyle="body-bold">
                      <a href={link.url} target="_blank" rel="noreferrer">
                        {link.text}
                      </a>
                    </TextButton>
                  ))}
                </Box>
              ) : undefined
            }
          >
            {alert.body}
          </Alert>
        );
      })}
    </Box>
  );
}
